import React from 'react';
import { Check, X } from 'lucide-react';
export function ForWho() {
  return <section className="py-20 bg-white" data-id="element-60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-62">
          {/* Left Column - For You */}
          <div className="bg-brand-dark text-white p-8 md:p-12 rounded-2xl shadow-xl" data-id="element-63">
            <h3 className="font-serif text-2xl md:text-3xl font-bold mb-8 flex items-center text-brand-gold" data-id="element-64">
              <Check className="h-8 w-8 mr-3 bg-brand-gold text-brand-dark rounded-full p-1" data-id="element-65" />
              ESTO ES PARA TI SI...
            </h3>
            <ul className="space-y-4" data-id="element-66">
              {['Tienes más de 40 años y sientes que tu metabolismo cambió', 'Te despiertas cansada aunque hayas dormido bien', 'Tu abdomen se hincha durante el día sin razón aparente', 'Has probado dietas y no funcionan como antes', 'Quieres resultados en 7 días, no en 7 meses', 'Vives en USA y quieres una guía práctica para tu supermercado'].map((item, i) => <li key={i} className="flex items-start" data-id="element-67">
                  <Check className="h-6 w-6 text-brand-gold mr-3 flex-shrink-0 mt-0.5" data-id="element-68" />
                  <span className="text-lg text-gray-100" data-id="element-69">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Right Column - Not For You */}
          <div className="bg-brand-cream text-brand-dark p-8 md:p-12 rounded-2xl border border-gray-200" data-id="element-70">
            <h3 className="font-serif text-2xl md:text-3xl font-bold mb-8 flex items-center text-red-600" data-id="element-71">
              <X className="h-8 w-8 mr-3 bg-red-100 text-red-600 rounded-full p-1" data-id="element-72" />
              ESTO NO ES PARA TI SI...
            </h3>
            <ul className="space-y-4" data-id="element-73">
              {['Buscas una solución mágica sin hacer nada', 'No estás dispuesta a cambiar 3 alimentos por 7 días', 'Quieres perder 30 libras en una semana', 'Prefieres seguir con lo que no te ha funcionado'].map((item, i) => <li key={i} className="flex items-start" data-id="element-74">
                  <X className="h-6 w-6 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-75" />
                  <span className="text-lg text-gray-700" data-id="element-76">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}